import {REOPEN_FAILED, API_CALL, RECEIVE_REOPEN, REQUEST_REOPEN} from "./types";
import {hasError} from "./actionHelpers";
import {toast} from "react-toastify";

export const reopenProposal = (id) => ({
  type: API_CALL,
  onRequest: REQUEST_REOPEN,
  onResponse: RECEIVE_REOPEN,
  onError: REOPEN_FAILED,
  responseKey: 'reopen',
  payload: {
    method: 'POST',
    url: `/ios/${id}/reopenProposal`
  }
});

export const reopenProposalWithNotifications = (id) => (dispatch, getState) => {
  let message = `Reopening proposal for ${id}`;
  toast.info(message, { theme: 'colored', toastId: message });
  return dispatch(reopenProposal(id)).then(() => {
    const err = hasError(getState(), 'reopenProposal', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
    } else {
      message = `Reopened proposal`;
      toast.success(message, { theme: 'colored', toastId: message });
    }
  });
};
